import React from 'react';

export default function OptionsProvider({ options, register, registerValue, defaultOption, headOptions, tailOptions, compareFn }) {
    const heads = [];
    const tails = [];
    if (!compareFn) compareFn = (a, b) => (a.value < b.value) ? -1 : (a.value > b.value) ? 1 : 0;
    options = options.sort(compareFn);
    if (headOptions) {
        for (let value of headOptions) {
            heads.push(...options?.filter(item => item.value === value));
            options = options?.filter(item => item.value !== value);
        }
    }
    if (tailOptions) {
        for (let value of tailOptions) {
            tails.push(...options?.filter(item => item.value === value));
            options = options?.filter(item => item.value !== value);
        }
    }
    return (
        <select {...register(registerValue)}>
            {defaultOption && <option value="" key="">{defaultOption}</option>}
            {heads?.
                map((option) => (
                    <option value={option.value} key={option.value}>
                        {option.label}
                    </option>
                ))}
            {options?.
                map((option) => (
                    <option value={option.value} key={option.value}>
                        {option.label}
                    </option>
                ))}
            {tails?.
                map((option) => (
                    <option value={option.value} key={option.value}>
                        {option.label}
                    </option>
                ))}
        </select>
    )
}